import * as t from 'io-ts'

export const JSONPrimitiveCodec = t.union([
  t.string,
  t.number,
  t.boolean,
  t.null,
  t.undefined
], 'JSONPrimitiveMap')
export const JSONValueCodec = t.union([
  t.record(t.string, JSONPrimitiveCodec),
  JSONPrimitiveCodec
])
// export const JSONObjectCodec = t.record(t.string, JSONValueCodec)
export const JSONObjectCodec = t.record(t.string, JSONValueCodec)
export const JSONArrayCodec = t.array(JSONObjectCodec)

export type JSONPrimitive = t.TypeOf<typeof JSONPrimitiveCodec>
export type JSONValue = t.TypeOf<typeof JSONValueCodec>
export type JSONObject = t.TypeOf<typeof JSONObjectCodec>
export type JSONArray = t.TypeOf<typeof JSONArrayCodec>
